export type PublishPlacementRow = {
  scheduled_at?: string | null;
  createdAt?: string | null;
};

export function publishPlacementIso(row: PublishPlacementRow): string | null {
  return row.scheduled_at || row.createdAt || null;
}

export function localDayKey(iso: string, timeZone: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date(iso));
  const get = (t: string) => parts.find((p) => p.type === t)?.value;
  return `${get('year')}-${get('month')}-${get('day')}`;
}

/** Group publish rows by local calendar day of their placement instant
 *  (`scheduled_at` when set, otherwise `createdAt`). Days are sorted by
 *  that instant ascending. */
export function bucketPublishesByLocalDay<T extends PublishPlacementRow>(
  rows: T[],
  timeZone: string,
): Map<string, T[]> {
  const buckets = new Map<string, T[]>();

  for (const row of rows) {
    const iso = publishPlacementIso(row);
    if (!iso) continue;
    const day = localDayKey(iso, timeZone);
    const list = buckets.get(day);
    if (list) list.push(row);
    else buckets.set(day, [row]);
  }

  for (const list of buckets.values()) {
    list.sort((a, b) => {
      const aIso = publishPlacementIso(a) ?? '';
      const bIso = publishPlacementIso(b) ?? '';
      return aIso < bIso ? -1 : aIso > bIso ? 1 : 0;
    });
  }

  return buckets;
}
